export default {
    en: {
        sale: "Sale",
        empty: "Sold Out"
    },
    uz: {
        sale: "Sotish",
        empty: "Sotilgan"
    },
    ru: {
        sale: "Продажа",
        empty: "Распродано"
    },
}